export default {
  'it': {
    'iubendaid': '63585245',
    'readmore': 'Approfondisci',
    'banner': {
      'scroll': 'Scopri di più'
    },
    'home': {
      'title': 'Il vostro partner per la produzione made in Italy',
      'banner1': {
        'title': 'Chi siamo',
        'text': `Fondata nel 1979, Weg è da sempre promotrice della ricerca, sviluppo e produzione del Made in Italy.<br>
        Affianca i suoi clienti nella progettazione delle collezioni maglieria e jersey, fino alla consegna della produzione con particolare attenzione al rispetto degli standard qualitativi e delle date di consegna.`
      },
      'sec1': {
        'title': 'Ricerca',
        'text': `Nella Moda essere al passo con l’evoluzione del mercato, capire in anticipo le tendenze stilistiche e l'attitudine dei consumatori è fondamentale per avere successo.<br>
        Per questo uno dei punti di forza di Weg è la costante ricerca di idee, materiali, prodotti e la loro continua sperimentazione.`
      },
      'sec2': {
        'title': 'Progettazione',
        'text': `Lavoriamo in stretta collaborazione con stilisti e responsabili di produzione.<br>Un capo di abbigliamento è il risultato di uno scambio di  informazioni, conoscenze, ed esperienze.<br>Nella massima riservatezza e correttezza professionale.`
      },
      'sec3': {
        'title': 'Realizzazione',
        'text': `Chi si rivolge al made in Italy esige qualità.<br>
          La Qualità è il frutto di un'attenta scelta di materie prime, di accessori e di tutti i dettagli che contribuiscono a rendere un capo un’esperienza unica per chi lo indosserà.<br>
          Nasce da questa consapevolezza la nostra quarantennale storia di successi.`
      },
      'sec4': {
        'title': 'Produzione',
        'text': `Le nostre unità produttive sono sinonimo di eccellenza nel settore maglieria. Possiamo contare su macchine di ultima generazione con finezze dalla 3 alla 21, tecniche jacquard ed intarsi, punti fantasia, multi-gauge e capo integrale (seamless).<br>Abbiamo, inoltre, la possibilità di realizzare lavorazioni in tinto capo, stampe e ricami.`
      },
      'sec5': {
        'title': 'Collaborazioni',
        'text': `<a href="https://www.ifmparis.fr/en/" target="_blank" rel="noopener">L'Institut Français de la Mode</a> è un’accademia nata dall’unione dell’Ecole de la Chambre Syndacale de la Couture Parisienne con l’IFM. <br>
        La fusione di queste due eccellenze del settore moda ha creato una scuola che ha per obiettivo la formazione dei futuri talenti.<br>
        Weg contribuisce al raggiungimento di questo ambizioso obiettivo accogliendo gli studenti del Master of Knitwear’s Art per un progetto di cui è parte integrante.`
      },
      'sec6': {
        'title': 'Sostenibilità',
        'text': `<h3>Materie prime ecologiche e riciclate</h3><br>
        Weg è costantemente impegnata nella ricerca e utilizzo di filati e tessuti composti da :<br>
        - materie prime di origine certificata eco-sostenibile <br>
        - materie prime già precedentemente utilizzate, quindi riciclate
        `
      },
      'contact': {
        'title': 'Contatti',
        'form': {
          'title': 'Hai una richiesta?<br>Compila il form.',
          'name': 'Nome',
          'email': 'Email',
          'phone': 'Telefono',
          'message': 'Messaggio',
          'policy': 'Accetto i termini della <a href="#policy">privacy policy</a>',
          'marketing': 'Do il consenso per attività di marketing',
          'send': 'Invia richiesta',
          'sent': 'Messaggio inviato',
          'requiredfields': 'Compila tutti i campi',
          'error': 'Errore invio messaggio'
        }
      }
    },
    'research': {
      'title': 'Ricerca',
      "text": `Nella Moda essere al passo con l’evoluzione del mercato, capire in anticipo le tendenze stilistiche e l'attitudine dei consumatori è fondamentale per avere successo.<br>
        Per questo uno dei punti di forza di Weg è la costante ricerca di idee, materiali, prodotti e la loro continua sperimentazione.<br>
        Ogni stagione proponiamo alla nostra clientela una “collezione di idee” maglieria, in linea con le tendenze filati e colori del momento, capi già realizzati da cui prendere spunto per sviluppare le proprie idee e modelli. I frequenti viaggi nelle maggiori capitali europee, in estremo oriente e negli Stati Uniti ci consentono di essere aggiornati ed informati su prodotti e mercati.<br>
      Grazie alla lunga esperienza e presenza sul mercato italiano possiamo gestire non solo prodotti in maglieria e tessuti a maglia ma anche capi di confezione, che facciamo realizzare soprattutto in centro-sud Italia, con tessuti acquistati e controllati direttamente.`
    },
    'design': {
      'title': 'Progettazione',
      'text':  `Lavoriamo in stretta collaborazione con stilisti e responsabili di produzione.<br>Un capo di abbigliamento è il risultato di uno scambio di  informazioni, conoscenze, ed esperienze.<br>Nella massima riservatezza e correttezza professionale.<br>
                Infatti qualsiasi capo d’ispirazione o punto maglia proposto e selezionato dal cliente viene ad esso attribuito in esclusiva.<br>
      Siamo in grado di lavorare su schizzo del cliente, su dettagli di immagini o capi vintage da riproporre e se necessario consigliare il cliente nella fase di prototipia e sviluppo collezione, sulle misure per realizzare volumi e vestibilità desiderate.`
    },
    'development': {
      'title': 'Realizzazione',
      'text': `Chi si rivolge al made in Italy esige qualità.<br>
          La Qualità è il frutto di un'attenta scelta di materie prime, di accessori e di tutti i dettagli che contribuiscono a rendere un capo un’esperienza unica per chi lo indosserà.<br>
          Nasce da questa consapevolezza la nostra quarantennale storia di successi.<br>
 Siamo molto attenti all’innovazione tecnologica ed alle materie prime sostenibili ed organiche, sperimentiamo ed innoviamo per stimolare continuamente la nostra clientela..`
    },
    'production': {
      'title': 'Produzione',
      'text': `Le nostre unità produttive sono sinonimo di eccellenza nel settore maglieria. Possiamo contare su macchine di ultima generazione con finezze dalla 3 alla 21, tecniche jacquard ed intarsi, punti fantasia, multi-gauge e capo integrale (seamless).<br>Abbiamo, inoltre, la possibilità di realizzare lavorazioni in tinto capo, stampe e ricami.<br>
 Controlliamo ogni fase del processo produttivo, testiamo  I filati prima di ordinarli, gestiamo I laboratori di tessitura, quelli di confezione fino alla fase di stiro-ripasso ed imbusto.<br>
      Il controllo qualita’ finale si svolge in tre fasi:<br>
      <ul><li>controllo della materia prima all’arrivo</li>
      <li>controllo nelle fase di avvio della produzione</li>
      <li>controllo dei capi finiti.</li></ul>`
    },
    'sustainability': {
      'title': 'Sostenibilità',
      'text': `Lavoriamo a stretto contatto con i nostri fornitori e partner per gestire conformità e prestazioni .<br>
      <br>
      <h3>Visione e Strategia</h3><br>
      Le persone che lavorano con noi rappresentano il fulcro della nostra azienda, quindi curiamo l’ambiente di lavoro affinché sia piacevole
      e soprattutto sicuro .<br>
      L’energia elettrica che utilizziamo è prodotta da pannelli solari installati sul tetto della nostra sede.<br>
      Creare energia rinnovabile e ridurre il consumo è per noi premessa indispensabile per progettare il nostro futuro.<br>
      Siamo lieti di poter condividere i nostri valori di sostenibilità con alcuni dei maggiori marchi di moda a livello internazionale.<br>
      <br>`
    },
    'about': {
      'title': 'Chi siamo',
      'text': `Fondata nel 1979, Weg è da sempre promotrice della ricerca, sviluppo e produzione del Made in Italy.<br>
        Affianca i suoi clienti nella progettazione delle collezioni maglieria e jersey, fino alla consegna della produzione con particolare attenzione al rispetto degli standard qualitativi e delle date di consegna.
    Nella nostra sede di Carpi, provincia di Modena, conserviamo un archivio storico dei capi realizzati in più di 40 anni di attività, per molti dei marchi internazionali con i quali abbiamo collaborato nel tempo.`
    }
  },
  'en': {
    'iubendaid': '10112003',
    'readmore': 'Read more',
    'banner': {
      'scroll': 'Discover more'
    },
    'home': {
      'title': 'Your partner for made in Italy production',
      'banner1': {
        'title': 'About us',
        'text': `Founded in 1979, Weg has always focused on research, development and production of  Made in Italy knitwear.<br>
        We work close to our customers from the design of collection till the delivery of goods, with special attention  on the respect of quality standards and deadlines.`
      },
      'sec1': {
        'title': 'Research',
        'text': `Fashion means being up to date on market’s evolution, trends and consumer’s attitude; this is the essential key to success. For this reason, one of Weg strengths is our constant search for new ideas, materials and techniques, as well as the continuous exploration towards new perspectives in fashion.`
      },
      'sec2': {
        'title': 'Design',
        'text': `We work closely with fashion designers and production managers. A fashion garment is  the result of an information, knowledge and experience’s exchange; in the most rigorous confidence and professional integrity.`
      },
      'sec3': {
        'title': 'Development',
        'text': `Who chooses Made in Italy products wants quality. Quality is the result of a careful choice of row materials, techniques and everything that contributes to making a garment a unique experience when worn. Our 40-year success comes from this awareness.`
      },
      'sec4': {
        'title': 'Production',
        'text': `Our production units distinguish themselves  by their ability to guarantee knitwear  excellence .We can count on the last  generation machines from 3 to 21 gauges, jacquard and intarsia techniques, fancy stitches, multi gauge abs seamless. Moreover, we can handle garment dyed, all over prints and embroideries.`
      },
      'sec5': {
        'title': 'Partnerships',
        'text': `
        <a href="https://www.ifmparis.fr/en/" target="_blank" rel="noopener">L'Institut Français de la Mode</a> is an academy born from  the union of the Ecole de la Chambre Syndacale de la Couture Parisienne and IFM.<br>
        The encounter of these two  fashion symbols  of excellence has created a school that aim to  build future talents character.<br>
        Weg contributes to the achievement of this ambitious goal , hosting students of the Master of Knitwear Art for a project that is an integral part of the master program.`
      },
      'sec6': {
        'title': 'Sustainability',
        'text': `
        We care about the respect of environment and sustainable industrial production.
        Weg constantly looks and promotes fibres and row materials with certified origin for eco-sustainability such as recycled and  organic row materials.

        <h3>Vision and Strategy</h3>
        According to our business philosophy, people who work with us are our most important asset and we take care of the work environment in order to make it pleasant and , above all, safe.<br>
        The electrical energy used in our company is produced by solar panels.<br>
        For us, providing renewable energies and reducing consumption is a starting point  to plan our future.<br>
        We are proud to say, we share our values of sustainability with some of the world's leading fashion brands.<br>
        <br>
        <h3>Ecological and recycled raw materials</h3>
        Weg constantly looks for raw materials with certified origin, highlighting the eco-sustainability  of the fibres and fabrics used in their production or employs previously used and recycled raw materials.<br>
        `
      },
      'contact': {
        'title': 'Contacts',
        'form': {
          'title': 'Please fill out this form and we will get in touch with you shortly.',
          'name': 'Name',
          'email': 'Email',
          'phone': 'Phone',
          'message': 'Message',
          'policy': '<a href="#policy">privacy policy</a>',
          'marketing': 'I acknowledge to personal data treatment for email marketing purposes.',
          'send': 'Send',
          'sent': 'Message sent',
          'requiredfields': 'Fill all required fields',
          'error': 'Failed sending message'
        }
      }
    },
    'research': {
      'title': 'Research',
      "text": `Fashion means being up to date on market’s evolution, trends and consumer’s attitude; this is the essential key to success for our Made in Italy. For this reason, one of Weg strengths is our constant search for new ideas, materials (sustainable yarns and fabrics) and techniques, as well as the continuous exploration towards new perspectives in fashion.<br>
                Every season we offer our customers a knitwear \"collection of ideas\", in line with the yarn and color trends of the moment, inspiration garments already made in order to develop their own ideas and styles. Frequent trips to major European capitals, the Far East and the United States allow us to be updated and informed about products and markets.<br>
                Thanks to our long experience and presence on the Italian market, we can manage not only knitwear and knitted fabrics products, but also woven garments, which we realize especially in central-southern Italy, with fabrics directly purchased and controlled.`
    },
    'design': {
      'title': 'Design',
      'text': `We work closely with fashion designers and production managers. A fashion garment is the result of an information, knowledge and experience’s exchange; in the most rigorous confidence and professional integrity, necessary for “private label”cooperations.<br>
      In fact, any inspirational garment or knitting stitch proposed and selected by the customer is of his own exclusivity.<br>
      We are able to work on customer's sketch, on details of images or finish garments to be re-proposed/restudied and, if necessary, we can give advise during proto making and collection development steps on the measures to create the desired volumes and wearability.`
    },
    'development': {
      'title': 'Development',
      'text': `Who chooses Made in Italy garments wants quality. Quality is the result of a careful choice of row materials (yarns and fabrics), techniques and everything that contributes to make a sweater, t-shirt or dress, a unique experience when worn. Our 40-year success comes from this awareness.<br>
      We are very attentive to technological innovation and sustainable and organic raw materials, we experiment and innovate to continuously inspire our customers.`
    },
    'production': {
      'title': 'Production',
      'text': `Our clothing factory can guarantee Made in Italy excellence knitwear and garments.<br>
      We can count on the last generation machines from 3 to 21 gauges, jacquard and intarsia techniques, fancy stitches, multi gauge and seamless. Moreover, we can handle garment dyed, all over prints and embroideries.<br>
      We check every step of the production process, we test the yarns before ordering them, we manage knitwear laboratories, the woven ones untill the ironing-final control and packaging phase.<br>
      The final quality control takes place in three steps:<br>
      <ul>
      <li>control of the raw material upon arrival</li>
      <li>control in the production start-up phase</li>
      <li>control of finished garments.</li>
      </ul>`
    },
    'sustainability': {
      'title': 'Sustainability',
      'text': `We care about the respect of environment and sustainable industrial production. Weg constantly looks for and promotes fibres, row materials and garments with certified origin for eco-sustainability such as recycled and organic row materials, yarns and fabrics.`
    },
    'about': {
      'title': 'About',
      'text': `Founded in 1979, Weg has always focused on research and development of knitwear and t-shirts private label.<br>
      We are manufacturing exclusively Made in Italy sweaters and garments in our factory, using especially sustainable materials and fabrics.<br>
      We work close to our customers from the design of collection ‘till the delivery of goods, with special attention on the respect of quality standards and deadlines.<br>
      In our headquarters in Carpi, in the province of Modena, we keep a historical archive of the garments made in more than 40 years of activity for many of the international brands with which we have collaborated over time.`
    }
  },
  'fr': {
    'iubendaid': '62574989',
    'readmore': 'En savoir plus',
    'banner': {
      'scroll': 'En savoir plus'
    },
    'home': {
      'title': 'Votre partnaire dans la production Made in Italy',
      'banner1': {
        'title': 'Qui nous sommes',
        'text': `Fondé en 1979, Weg a toujours promu la recherche, le développement et la production du Made in Italy.<br>
        La maison accompagne ses clients depuis la conception des collections d'articles en tricot et de tissus à maille, jusqu'à la livraison de la production, en prêtant une attention particulière au respect des normes de qualité et des délais de livraison.`
      },
      'sec1': {
        'title': 'Recherche',
        'text': `Pour réussir dans le domaine de la mode, il est essentiel d'être à jour avec l'évolution du marché et de comprendre à l'avance les tendances stylistiques et  des consommateurs.<br>
        Voilà pourquoi  Weg est à la constante recherche d'idées,matériaux, produits et les expérimente continuellement.`
      },
      'sec2': {
        'title': 'Convevoir',
        'text': `Nous travaillons en étroite collaboration avec les stylistes et les responsables de production.<br>
         Un vêtement naît de l'échange d’informations, connaissances et expériences .<br>
         Dans une confidentialité et correction professionnelle absolue.`
      },
      'sec3': {
        'title': 'Réalisation',
        'text': `Qui choisit le Made in Italy exige qualité.<br>
         La qualité est le résultat d’une choix attentive de matières premières, des accessoires et tous les détails qui contribuent à rendre un vêtement une expérience unique pour ceux qui le porteront.<br>
         C'est de cette conscience que nos quarante ans de succès naît.`
      },
      'sec4': {
        'title': 'Production',
        'text': `Nos unités de production se caractérisent par leur excellence dans le domaine du tricot. Nous pouvons compter sur des machines de dernière génération avec jauge de la 3 à la 21 , techniques jacquard et intarsia, points fantaisie, multi-jauge  et sans couture.<br>
        Nous avons aussi la possibilité de realiser du teint en pièce, impression et broderie.`
      },
      'sec5': {
        'title': 'Collaborations',
        'text': `<a href="https://www.ifmparis.fr/en/" target="_blank" rel="noopener">L'Institut Français de la Mode</a> est une académie née de l'union de l'École de la Chambre Syndicale de la Couture Parisienne et de l'IFM.<br>
        
        La fusion de ces excellences de la mode a crée une école qui vise à former les talents de l’avenir.<br>
        Weg contribue à la réalisation de cet objectif ambitieux en accueillant les étudiants du Master of Knitwear's Art pour un projet dont il est partie intégrante.`
      },
      'sec6': {
        'title': 'Durabilité',
        'text': `<h3>Matières premières écologiques et recyclées</h3><br>
        Weg est toujours à la recherche de fils et tissus composés par :<br>
        -Matières premières d'origine certifiée pour éco-durabilité <br>
        -Matières premières précédemment utilisées donc recyclées.<br>
        <br>
        <h3>Vision et stratégie</h3><br>
        Les personnes qui travaillent avec nous sont le cœur de notre entreprise. Nous prenons donc soin de l'environnement de travail pour qu'il soit agréable et, surtout, sûr.<br>
        L'énergie électrique utilisée dans notre entreprise est produite par des panneaux solaires installés sur le toit de notre siège.<br>
        Pour nous, la production d'énergies renouvelables et la réduction de la consommation sont les bases indispensables pour planifier notre avenir.<br>
        Nous sommes heureux de pouvoir partager nos valeurs de développement durable avec certaines des plus célèbres maisons à l'échelle mondiale`
      },
      'contact': {
        'title': 'Contact',
        'form': {
          'title': 'Merci de remplir ce formulaire nous prendrons contact avec vous rapidement',
          'name': 'Nom',
          'email': 'Email',
          'phone': 'Télephone',
          'message': 'Demande',
          'policy': '<a href="#policy">Politique de confidentialité</a>',
          'marketing': 'Je consens au traitement de mes données personnelles pour email marketing.',
          'send': 'Envoyer',
          'sent': 'Message envoyé',
          'requiredfields': 'Remplissez tous les champs',
          'error': `Erreur d'envoi du message`
        }
      }
    },
    'research': {
      'title': 'Recherche',
      "text": `Pour réussir dans le domaine de la mode, il est essentiel d'être à jour avec l'évolution du marché et de comprendre à l'avance les tendances stylistiques et  des consommateurs.<br>
      Voilà pourquoi  Weg est à la constante recherche d'idées,matériaux, produits et les expérimente continuellement.<br>
      Chaque saison, nous proposons à nos clients une "collection d'idées" de tricot, en ligne avec les tendances fils et couleurs du moment, des vêtements déjà realisés auxquels ils peuvent s'inspirer pour développer leurs propres idées et modèles. Les déplacements fréquents dans les grandes capitales européennes, l'Extrême-Orient et les États-Unis nous permettent d'être mis à jour et informés sur les produits et les marchés.<br>
Grâce à notre longue expérience et à notre présence sur le marché italien, nous pouvons gérer pas seulement la maille et des tissus tricotés, mais aussi des vêtements que nous faisons realiser spécialement dans le centre-sud de l'Italie, avec des tissus achetés et contrôlés directement.`
    },
    'design': {
      'title': 'Concevoir',
      "text": `Nous travaillons en étroite collaboration avec les stylistes et les responsables de production.<br>
      Un vêtement naît de l'échange d’informations, connaissances et expériences .<br>
      Dans une confidentialité et correction professionnelle absolue.<br>
      En effet, chaque vêtement d'inspiration ou tricotage proposé et sélectionné par le client lui est exclusivement attribué.
      Nous sommes capables de travailler sur le croquis du client, sur des détails d'images ou de vêtements vintage à re-proposer et si nécessaire conseiller le client dans la phase de prototypage et de développement de la collection, sur les mesures pour créer les volumes et la portabilité souhaités.<br>`
    },
    'development': {
      'title': 'Réalisation',
      "text": `Qui choisit le Made in Italy exige qualité.<br>
      La qualité est le résultat d’une choix attentive de matières premières, des accessoires et tous les détails qui contribuent à rendre un vêtement une expérience unique pour ceux qui le porteront.<br>
      C'est de cette conscience que nos quarante ans de succès naît.<br>
      Nous sommes très attentifs à l'innovation technologique et aux matières premières soutenables et organiques, nous expérimentons et innovons pour encourager constamment nos clients.`
    },
    'production': {
      'title': 'Production',
      "text": `Nos unités de production se caractérisent par leur excellence dans le domaine du tricot. Nous pouvons compter sur des machines de dernière génération avec jauge de la 3 à la 21 , techniques jacquard et intarsia, points fantaisie, multi-jauge  et sans couture.<br>
      Nous avons aussi la possibilité de realiser du teint en pièce, impression et broderie.<br>
      Nous contrôlons chaque phase du processus de fabrication, nous testons les fils avant de les commander, nous gérons les ateliers de tricotage, ceux de confection jusqu'à la phase de repassage, contrôle et de conditionnement.
Le contrôle qualité final se déroule en trois phases :<br>
    • contrôle de la matière première à l'arrivée<br>
    • contrôle en phase de démarrage de la production<br>
    • contrôle des vêtements finis.`
    },

    'sustainability': {
      'title': 'Durabilité',
      "text": `Nos unités de production se caractérisent par leur excellence dans le domaine du tricot. Nous pouvons compter sur des machines de dernière génération avec jauge de la 3 à la 21 , techniques jacquard et intarsia, points fantaisie, multi-jauge  et sans couture.<br>
      Nous avons aussi la possibilité de realiser du teint en pièce, impression et broderie.<br>
      Nous contrôlons chaque phase du processus de fabrication, nous testons les fils avant de les commander, nous gérons les ateliers de tricotage, ceux de confection jusqu'à la phase de repassage, contrôle et de conditionnement.
Le contrôle qualité final se déroule en trois phases :<br>
    • contrôle de la matière première à l'arrivée<br>
    • contrôle en phase de démarrage de la production<br>
    • contrôle des vêtements finis.`
    }
    
  }
}
